<div class="flex items-center " [ngClass]="last ? 'justify-start' : 'justify-center flex-1'" *ngFor="let step of steps; let i = index; let last = last">
    <div class="progress-step relative z-20 flex flex-col" [class.active]="i <= currentStep">
        <div class="progress-circle" [ngClass]="!!last ? 'relative left-[-0.0625rem] shadow-06' : 'relative left-[0.3125rem]'">
            <div class="active font-bold" *ngIf="i >= currentStep">{{i + 1}}</div>
            <fa-icon [icon]="faCheckCircle" class="color-secondary icon flex" *ngIf="i + 1 <= currentStep"></fa-icon>
        </div>
        <p class="absolute top-10  color-primary text-[0.625rem]" [ngClass]="{'left-[0.3125rem]': !last}">{{!last ? 'Basic Info' : 'Operational Settings'}}</p>
    </div>
    <div class="progress relative z-10 flex-[1_0_93%]" *ngIf="!last">
        <div class="range" [class.active]="i + 1 <= currentStep"></div>
    </div>
</div>